import styled from '@emotion/styled';

interface Props {
    isThin?: boolean;
}

function Divider({ isThin }:Props) {
    return (isThin ? <Thin aria-label='divider' /> : <Normal aria-label='divider' />);
}

const Normal = styled.div`
    background-color: var(--color-gray2);
    border-top: 1px solid var(--color-gray3);
    height: 8px;
    min-height: 8px;
    width: 100%;
`;

const Thin = styled.div`
    background-color: var(--color-gray3);
    height: 1px;
    width: 100%;
`;

export default Divider;
